var t=function(t){var e=document.querySelector(".".concat(t," .slots-track"));return e?e.childNodes:null};export{t as default};
